import { useTranslation } from "react-i18next";

import DropdownWithSearch from "features/ui/DropdownWithSearch/DropdownWithSearch";
import { SchemaEntry } from "features/ui/MaterialTable";
import { SelectOption } from "features/ui/Select";

interface Props {
  selected: string | null;
  schema?: SchemaEntry<string>[];
  onChange: (selected: string) => void;
  disabled?: boolean;
  attributePlaceholder?: string;
  openOnAutoFocus?: boolean;
  hasInitialFocus?: boolean;
  isInsideFilterBuilder?: boolean;
}

const AttributeSelect = ({
  selected,
  schema,
  onChange,
  disabled,
  attributePlaceholder,
  openOnAutoFocus,
  hasInitialFocus,
  isInsideFilterBuilder = false,
}: Props) => {
  const { t } = useTranslation("filters");
  const options = schema?.map(({ label, filter, dropdownGroup }) => ({
    id: filter?.fieldName as string,
    value: filter?.label || label,
    group: dropdownGroup,
  }));

  const attributeSelectOption: SelectOption<string> | null =
    selected && options
      ? {
          id: selected,
          value: options.find(({ id }) => id === selected)?.value || selected,
        }
      : null;

  if (!options) return null;

  const placeholder = attributePlaceholder || t("select_attribute");

  return (
    <>
      <DropdownWithSearch
        autoFocus={attributeSelectOption === null && hasInitialFocus}
        options={options}
        selectedOption={attributeSelectOption}
        onSelectedOptionChange={(selected) =>
          onChange(selected ? selected.id : "")
        }
        testId="attribute-select-wrap"
        placeholder={placeholder}
        fullWidth={!isInsideFilterBuilder}
        disabled={disabled}
        openOnAutoFocus={openOnAutoFocus}
        disableClearable={attributeSelectOption !== null}
        popperClassName={isInsideFilterBuilder ? "filterBuilder" : "w-80"}
      />
    </>
  );
};
export default AttributeSelect;
